import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lakeGeorgeConfig } from "./data";

export default function LakeGeorgePage() {
  return <CityPageTemplate config={lakeGeorgeConfig} />;
}